export const cubeBrands = [
  {
    label: 'GAN',
    value: 'GAN'
  },
  {
    label: 'GAN-MG',
    value: 'GAN-MG'
  },
  {
    label: '魔域',
    value: 'MOYU'
  },
  {
    label: '魅龙',
    value: 'MOYU-MeiLong'
  },
  {
    label: '奇艺',
    value: 'QiYi'
  },
  {
    label: '永骏',
    value: 'Yongjun'
  },
  {
    label: '圣手',
    value: 'Shengshou'
  },
  {
    label: '点盛',
    value: 'Diansheng'
  },
  {
    label: '裕鑫',
    value: 'Yuxin'
  },
  {
    label: '大雁',
    value: 'Dayan'
  },
  {
    label: '史塔克',
    value: 'SpeedStacks'
  },
  {
    label: '泛新',
    value: 'Fanxin'
  },
  {
    label: '魔方吧',
    value: 'MF8'
  },
  {
    label: '旋风小子',
    value: 'CycloneBoys'
  },
  {
    label: '凌奥',
    value: 'Lingao'
  },
  {
    label: '蓝蓝',
    value: 'Lanlan'
  },
  {
    label: 'VeryPuzzle',
    value: 'VeryPuzzle'
  },
  {
    label: '功夫',
    value: 'Kungfu'
  },
  {
    label: '方是',
    value: 'Fangshi'
  },
  {
    label: 'Zcube',
    value: 'Zcube'
  },
  {
    label: '乐方',
    value: 'Lefun'
  },
  {
    label: '国丙',
    value: 'WitEden'
  },
  {
    label: 'XHMOBER',
    value: 'XHMOBER'
  },
  {
    label: '计客',
    value: 'Giiker'
  },
  {
    label: 'CubeTwist',
    value: 'CubeTwist'
  },
  {
    label: '合树',
    value: 'HeShu'
  },
  {
    label: 'MAD HEDZ',
    value: 'MAD HEDZ'
  },
  {
    label: '小丸号',
    value: 'MARU'
  },
  {
    label: '奇积',
    value: 'QJ'
  },
  {
    label: '巴克球',
    value: 'Neo Cube'
  },
  {
    label: '其他',
    value: 'Others'
  },
]

export const cubeCategories = [
  {
    label: '1x3x3',
    value: '1x3x3',
  },
  {
    label: '1x2x3',
    value: '1x2x3',
  },
  {
    label: '2x2x3',
    value: '2x2x3',
  },
  {
    label: '2x3x3',
    value: '2x3x3',
  },
  {
    label: '2x2x2',
    value: '2x2x2',
  },
  {
    label: '3x3x3',
    value: '3x3x3',
  },
  {
    label: '4x4x4',
    value: '4x4x4',
  },
  {
    label: '5x5x5',
    value: '5x5x5',
  },
  {
    label: '6x6x6',
    value: '6x6x6',
  },
  {
    label: '7x7x7',
    value: '7x7x7',
  },
  {
    label: '8x8x8',
    value: '8x8x8',
  },
  {
    label: '9x9x9',
    value: '9x9x9',
  },
  {
    label: 'Mastermorphix',
    value: 'Mastermorphix',
  },
  {
    label: 'Megaminx',
    value: 'Megaminx',
  },
  {
    label: 'Mirror',
    value: 'Mirror',
  },
  {
    label: 'Pyraminx',
    value: 'Pyraminx',
  },
  {
    label: 'SQ-1',
    value: 'SQ-1',
  },
  {
    label: 'Skewb',
    value: 'Skewb',
  },
  {
    label: '10x10x10',
    value: '10x10x10',
  },
  {
    label: '11x11x11',
    value: '11x11x11',
  },
  {
    label: '12x12x12',
    value: '12x12x12',
  },
  {
    label: '13x13x13',
    value: '13x13x13',
  },
  {
    label: '14x14x14',
    value: '14x14x14',
  },
  {
    label: '15x15x15',
    value: '15x15x15',
  },
  {
    label: 'Irregular Cube',
    value: 'Irregular Cube',
  },
  {
    label: '17x17x17',
    value: '17x17x17',
  },
  {
    label: 'Gift Package',
    value: 'Gift Package',
  },
  {
    label: 'Accessories',
    value: 'Accessories',
  },
  {
    label: 'Keychain',
    value: 'Keychain',
  },
  {
    label: 'Other toys',
    value: 'Other toys',
  },
]